/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseCountryResponseDto>;
export function request(body: defs.basics.BaseCountryRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCountry/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
